// extracted by mini-css-extract-plugin
module.exports = {"root":"PDPInfoSlider_root__KgHWp","rotation":"PDPInfoSlider_rotation__2ZahM"};